import { useState } from "react";
import { cn } from "../../lib/utils";

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  className?: string;
  showTooltip?: boolean;
}

export function TruncatedText({
  text,
  maxLength = 50,
  className = "",
  showTooltip = true,
}: TruncatedTextProps) {
  const [showFullText, setShowFullText] = useState(false);

  if (!text) return <span className={className}>-</span>;

  const isTextTruncated = text.length > maxLength;
  const displayText =
    isTextTruncated && !showFullText ? `${text.slice(0, maxLength)}...` : text;

  if (!isTextTruncated) {
    return <span className={className}>{text}</span>;
  }

  return (
    <div className="relative group">
      <span
        className={cn("cursor-pointer", className)}
        onClick={() => setShowFullText(!showFullText)}
        title={showTooltip ? text : undefined}
      >
        {displayText}
      </span>

      {/* Tooltip on hover - only show if showTooltip is true */}
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block z-50">
          <div className="bg-black text-white text-xs rounded py-1 px-2 max-w-xs break-words shadow-lg">
            {text}
            <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black"></div>
          </div>
        </div>
      )}
    </div>
  );
}

interface TruncatedTableCellProps {
  text: string;
  maxLength?: number;
  className?: string;
}

export function TruncatedTableCell({
  text,
  maxLength = 40,
  className = "",
}: TruncatedTableCellProps) {
  return (
    <div className={cn("max-w-[200px]", className)}>
      <TruncatedText text={text} maxLength={maxLength} className="block" />
    </div>
  );
}
